import axios from './configAxiosOrganizations';

export const getOneOrganization = async (orgId) => {
	return await axios.get(`/${orgId}/`);
};
